import { useGLTF } from "@react-three/drei"
import { useKTX2 } from "../../../utils/useKtx"
import * as THREE from 'three'
import { useEffect, useMemo, useRef, useState } from "react"
import { CuboidCollider, RigidBody } from "@react-three/rapier"
import { useSceneRef } from "../../../RefsProvider"
import { useFrame } from "@react-three/fiber"





export function CliffOne({ scale, position, rotation }) {
    const { nodes } = useGLTF('./models/04/cliff01.glb')
    const cliffBase = useKTX2('./textures/04/cliff01_base.ktx2')
    const cliffNormal = useKTX2('/textures/04/cliff01_normal.ktx2')

    const cliffMaterial = new THREE.MeshStandardMaterial({
        roughness: 0.6,
        metalness: 0.6,
        map: cliffBase,
        normalMap: cliffNormal
    })
    return (

        <RigidBody
            colliders={false}
            position={position}
            rotation={rotation}
            scale={scale}
            type="fixed"
        >
            <group dispose={null}>
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.SM_cliff01.geometry}
                    material={cliffMaterial}
                />
            </group>
            <CuboidCollider
                rotation={[0, Math.PI * 0.26, 0]}
                position={[-0.5, 0, 0.1]}
                args={[3.3, 1.5, 3]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0.1, 0]}
                position={[-0.5, 2.5, 0.5]}
                args={[3, 1, 2.5]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0.4, 0]}
                position={[0.5, 4.5, 0]}
                args={[1.6, 1, 1.9]}
            />
        </RigidBody>

    )
}
useGLTF.preload('./models/04/cliff01.glb')

export function CliffTwo({ scale, position, rotation }) {
    const { nodes } = useGLTF('./models/04/cliff02.glb')
    const cliffBase = useKTX2('./textures/04/cliff02_base.ktx2')
    const cliffNormal = useKTX2('/textures/04/cliff02_normal.ktx2')

    const cliffMaterial = new THREE.MeshStandardMaterial({
        roughness: 0.6,
        metalness: 0.6,
        map: cliffBase,
        normalMap: cliffNormal
    })

    return (
        <RigidBody
            type="fixed"
            colliders={false}
            position={position}
            rotation={rotation}
            scale={scale}   // 👈 on scale TOUT le rigidbody (mesh + colliders)
        >
            <group dispose={null}>
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.SM_cliff02.geometry}
                    material={cliffMaterial}
                />
            </group>

            {/* positions/args = valeurs pour un scale "1,1,1" */}
            <CuboidCollider
                rotation={[0, Math.PI * 0.0, 0]}
                args={[2, 3, 2]}
            />
            <CuboidCollider
                position={[0.5, 0, -0.4]}
                args={[1.2, 6, 1]}
            />
            <CuboidCollider
                position={[-0.6, 0, 0.]}
                rotation={[0, Math.PI * 0.25, 0]}
                args={[1.6, 7.5, 0.8]}
            />
        </RigidBody>
    )
}
useGLTF.preload('./models/04/cliff03.glb')

export function CliffThree({ position, scale, rotation }) {
    const { nodes } = useGLTF('./models/04/cliff03.glb')
    const cliffBase = useKTX2('./textures/04/cliff03_base.ktx2')
    const cliffNormal = useKTX2('/textures/04/cliff03_normal.ktx2')

    const cliffMaterial = new THREE.MeshStandardMaterial({
        roughness: 0.6,
        metalness: 0.6,
        map: cliffBase,
        normalMap: cliffNormal
    })
    return (
        <RigidBody
            type="fixed"
            colliders={false}
            position={position}
            rotation={rotation}
            scale={scale}
        >
            <group dispose={null}>
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.SM_cliff04.geometry}
                    material={cliffMaterial}
                />
            </group>
            <CuboidCollider
                rotation={[0, Math.PI * 0, 0]}
                position={[0, 0, 0]}
                args={[1.8, 1.5, 1.7]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * -0.01, 0]}
                position={[0.1, 2.2, 0]}
                args={[1.3, 0.8, 1.2]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0.05, 0]}
                position={[0.35, 3.8, -0.1]}
                args={[0.9, 0.8, 0.8]}
            />

        </RigidBody >

    )
}
useGLTF.preload('./models/04/cliff03.glb')

export function Arche({ position, scale, rotation }) {
    const archeOneBase = useKTX2('./textures/04/archeOne-base.ktx2')
    const archeOneNormal = useKTX2('./textures/04/archeOne-normal.ktx2')
    const archeTwoBase = useKTX2('./textures/04/archeTwo-base.ktx2')
    const archeTwoNormal = useKTX2('./textures/04/archeTwo-normal.ktx2')

    const archeOneMat = new THREE.MeshStandardMaterial({
        map: archeOneBase,
        normalMap: archeOneNormal,
        roughness: 0.6,
        metalness: 0.2,
    })
    const archeTwoMat = new THREE.MeshStandardMaterial({
        map: archeTwoBase,
        normalMap: archeTwoNormal,
        roughness: 0.6,
        metalness: 0.2
    })
    const { nodes } = useGLTF('./models/04/arche.glb')

    return (
        <RigidBody
            type="fixed"
            colliders={false}
            position={position}
            rotation={rotation}
            scale={scale}
        >
            <group dispose={null}>
                <group>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.SM_arch01_3.geometry}
                        material={archeOneMat}
                    />
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.SM_arch01_3001.geometry}
                        material={archeTwoMat}
                    />
                </group>
            </group>
            <CuboidCollider
                rotation={[0, Math.PI * 0, 0]}
                position={[-1.51, 1.5, 0]}
                args={[0.22, 1.5, 0.22]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0, 0]}
                position={[-1.51, 2.7, 0]}
                args={[0.4, 0.1, 0.4]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0, 0]}
                position={[1.51, 1.5, 0]}
                args={[0.22, 1.5, 0.22]}
            />
            <CuboidCollider
                rotation={[0, Math.PI * 0, 0]}
                position={[1.51, 2.7, 0]}
                args={[0.4, 0.1, 0.4]}
            />
        </RigidBody>
    )
}
useGLTF.preload('./models/04/arche.glb')

export function Dalle({ scale, position, rotation, index }) {
    const ref = useRef()
    const refOvni = useSceneRef("ovni")
    const activated = useRef(index === 0)        // la première est déjà en l'air
    const riseY = useRef(position[1])           // hauteur animée
    const wobbleProgress = useRef(activated.current ? 1 : 0) // 0 → 1

    const dalleBase = useKTX2('./textures/04/dalle-base.ktx2')
    const dalleNormal = useKTX2('./textures/04/dalle-normal.ktx2')
    const { nodes } = useGLTF('./models/04/dalle.glb')

    const dalleMat = new THREE.MeshStandardMaterial({
        map: dalleBase,
        normalMap: dalleNormal,
        roughness: 0.6,
        metalness: 0.2,
    })

    const baseY = position[1]
    const radiusXZ = 8   // tolérance horizontale
    const toleranceY = 5  // tolérance verticale

    // paramètres de lévitation / rotation, aléatoires par dalle
    const floatPhase = useMemo(() => Math.random() * Math.PI * 2, [])
    const floatAmp = useMemo(() => 0.08 + Math.random() * 0.05, [])
    const floatSpeed = 2

    // rotation wobble sur X/Y/Z
    const rotPhaseX = useMemo(() => Math.random() * Math.PI * 2, [])
    const rotPhaseY = useMemo(() => Math.random() * Math.PI * 2, [])
    const rotPhaseZ = useMemo(() => Math.random() * Math.PI * 2, [])

    const rotAmpX = useMemo(() => 0.1 + Math.random() * 0.04, [])
    const rotAmpY = useMemo(() => 0.1 + Math.random() * 0.04, [])
    const rotAmpZ = useMemo(() => 0.1 + Math.random() * 0.04, [])
    const rotSpeed = 2.5

    // easing InOut pour l’amplitude (0 → 1)
    const easeInOutCubic = (t) =>
        t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

    useFrame((state, delta) => {
        if (!ref.current) return

        const loweredY = baseY - 10

        // déclenchement
        if (!activated.current && refOvni.current) {
            const p = refOvni.current.translation
                ? refOvni.current.translation()
                : refOvni.current.position

            const dx = p.x - position[0]
            const dy = p.y - position[1]
            const dz = p.z - position[2]
            const distXZ = Math.sqrt(dx * dx + dz * dz)

            if (distXZ < radiusXZ && Math.abs(dy) < toleranceY) {
                activated.current = true
            }
        }

        // easing vers la hauteur cible (montée)
        const targetBase = activated.current ? baseY : loweredY
        riseY.current = THREE.MathUtils.damp(
            riseY.current,
            targetBase,
            6,
            delta
        )

        // progression d’amplitude (0 → 1) avec easeInOut
        const targetProgress = activated.current ? 1 : 0
        wobbleProgress.current = THREE.MathUtils.damp(
            wobbleProgress.current,
            targetProgress,
            3,
            delta
        )
        const eased = easeInOutCubic(THREE.MathUtils.clamp(wobbleProgress.current, 0, 1))

        const t = state.clock.getElapsedTime()

        // lévitation (amplitude modulée par eased)
        const floatOffset =
            Math.sin(t * floatSpeed + floatPhase) * floatAmp * eased

        // position finale
        ref.current.position.set(
            position[0],
            riseY.current + floatOffset,
            position[2]
        )

        // rotation de base + wobble sur X/Y/Z, modulé par eased
        if (rotation) {
            ref.current.rotation.x =
                rotation[0] +
                (activated.current
                    ? Math.sin(t * rotSpeed + rotPhaseX) * rotAmpX * eased
                    : 0)

            ref.current.rotation.y =
                rotation[1] +
                (activated.current
                    ? Math.sin(t * rotSpeed + rotPhaseY) * rotAmpY * eased
                    : 0)

            ref.current.rotation.z =
                rotation[2] +
                (activated.current
                    ? Math.sin(t * rotSpeed + rotPhaseZ) * rotAmpZ * eased
                    : 0)
        }
    })

    return (
        <group
            ref={ref}
            position={[position[0], baseY - 4, position[2]]}
            rotation={rotation}
            scale={scale}
            dispose={null}
        >
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.SM_stair02.geometry}
                material={dalleMat}
            />
        </group>
    )
}
useGLTF.preload('./models/04/dalle.glb')

